


export function handleARSearch(email = '', roles = []){
    const params = new URLSearchParams();
    if (!email){
        console.error("Email not provided")
    }
    params.append('email', email.trim().toLowerCase());
    if (roles && roles.length > 0) {
        params.append('roles', JSON.stringify(roles));
    }
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/user?${params.toString()}`)
}

/**
 * Add an authorized representative to a property owner organization
 * @param {String} organization_rid - The property owner organization record ID
 * @param {Object} arUser - The authorized representative user object (must include rid)
 * @returns {Promise} Fetch promise
 */
export function handleARAdd(organization_rid, arUser){
    if (!organization_rid) {
        console.error("Organization RID not provided");
    }
    if (!arUser || !arUser.rid) {
        console.error("AR user object with rid not provided");
    }

    return fetch(
        `${process.env.VUE_APP_API_BASE_URL}/user/authorized-reps/${organization_rid}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(arUser)
        }
    );
}

/**
 * Deactivate an authorized representative (sets status to "Inactive")
 * @param {String} ar_property_owner_rid - The AR Property Owner record ID
 * @returns {Promise} Fetch promise
 */
export function handleARDeactivate(ar_property_owner_rid) {
    if (!ar_property_owner_rid) {
        console.error("AR Property Owner RID not provided");
    }

    return fetch(
        `${process.env.VUE_APP_API_BASE_URL}/user/authorized-reps/${ar_property_owner_rid}/deactivate`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            }
        }
    );
}

/**
 * Clear AR from all properties (sets related_ar to empty string on BuildingOwner records)
 * @param {String} ar_property_owner_rid - The AR Property Owner record ID
 * @returns {Promise} Fetch promise
 */
export function handleClearARFromProperties(ar_property_owner_rid) {
    if (!ar_property_owner_rid) {
        console.error("AR Property Owner RID not provided");
    }

    return fetch(
        `${process.env.VUE_APP_API_BASE_URL}/properties/ar/${ar_property_owner_rid}`,
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        }
    );
}
